import { PaginationComponent } from 'components/common';
import { useDispatch, useSelector } from 'react-redux';
import { selectPagination, setPage } from 'ducks/events';
import React from 'react';

export const EventsPagination = (props: unknown) => {
    const dispatch = useDispatch();

    const pagination = useSelector(selectPagination);

    const handleSetPage = React.useCallback(
        (page: number) => {
            dispatch(setPage({ page }));
        },
        [dispatch],
    );
    return (
        <PaginationComponent
            {...props}
            pagination={pagination}
            setPage={handleSetPage}
        />
    );
};
